var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudHosting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 88.8193C25 86.5691 25 84.329 25 82.0788C25.1003 81.8176 25.2208 81.5564 25.291 81.2852C25.9433 78.7939 26.3146 76.1921 27.2779 73.8314C30.9607 64.7703 37.5234 58.6827 46.8156 55.5887C47.5682 55.3376 47.8693 55.0061 47.9295 54.1723C48.0399 52.6253 48.2506 51.0582 48.5918 49.5413C53.6594 26.6877 81.1045 17.2851 99.1069 32.2429C99.9599 32.9561 100.532 33.0164 101.495 32.494C108.57 28.6767 116.186 27.3909 124.013 28.8977C138.423 31.6803 147.956 40.219 152.412 54.2828C152.663 55.0864 153.044 55.5485 153.897 55.8398C158.111 57.2563 161.804 59.5768 165.076 62.6005C176.515 73.1684 178.271 91.3307 168.969 103.767C162.436 112.497 153.666 116.726 142.768 116.716C114.259 116.686 85.7606 116.716 57.2518 116.696C55.4556 116.696 53.6292 116.646 51.8631 116.354C39.9117 114.385 31.623 107.735 27.0973 96.5142C26.1038 94.0631 25.6824 91.391 25 88.8193Z",
    fill: "url(#paint0_linear_71_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 136.013C25.3512 134.858 25.6322 133.673 26.0637 132.558C28.452 126.289 34.3725 122.18 40.9553 122.17C47.779 122.16 53.7095 126.199 56.1078 132.568C56.4691 133.532 56.9106 133.914 57.9843 133.904C62.2291 133.833 66.4738 133.873 70.7185 133.873C71.15 133.873 71.5714 133.823 72.1133 133.793V125.596H80.9339C80.9339 128.127 80.9339 130.649 80.9339 133.17C80.9339 134.737 80.9339 136.294 80.9339 137.862C80.9138 140.885 79.1577 142.714 76.1373 142.724C70.0863 142.754 64.0353 142.764 57.9843 142.704C56.9307 142.704 56.4591 143.035 56.0978 144.019C53.6192 150.639 46.926 154.949 40.0622 154.417C32.8171 153.854 26.8665 148.691 25.3311 141.639C25.2609 141.327 25.1204 141.026 25.01 140.714C25.01 139.147 25.01 137.59 25.01 136.023L25 136.013Z",
    fill: "url(#paint1_linear_71_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2138 175C97.3308 174.779 96.4377 174.578 95.5546 174.337C89.2126 172.589 84.2053 166.451 83.8842 160.062C83.5229 152.699 87.5669 146.3 94.1799 143.778C94.6314 143.608 95.073 143.417 95.6048 143.206V125.566H104.295V143.226C107.436 144.271 110.095 145.828 112.152 148.299C116.036 152.99 117.17 158.294 115.183 164.04C113.156 169.907 108.891 173.393 102.83 174.689C102.459 174.769 102.107 174.9 101.736 175H98.2239H98.2138Z",
    fill: "url(#paint2_linear_71_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.016 125.546H127.776V133.873C129.974 133.873 132.011 133.873 134.048 133.873C136.687 133.873 139.316 133.813 141.955 133.904C143.019 133.934 143.481 133.552 143.842 132.578C146.28 126.098 152.432 121.979 159.285 122.18C166.169 122.381 172.06 126.801 174.207 133.361C177.8 144.371 168.588 155.662 157.148 154.256C150.656 153.452 146.22 149.936 143.812 143.889C143.431 142.934 142.949 142.693 141.996 142.703C136.085 142.744 130.185 142.734 124.274 142.724C120.682 142.724 119.026 141.046 119.016 137.43C119.016 133.522 119.016 129.614 119.016 125.546Z",
    fill: "url(#paint3_linear_71_734)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_734",
    x1: 99.9722,
    y1: 25.001,
    x2: 99.9722,
    y2: 116.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_734",
    x1: 52.967,
    y1: 122.17,
    x2: 52.967,
    y2: 154.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_734",
    x1: 100.003,
    y1: 125.566,
    x2: 100.003,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_734",
    x1: 147.006,
    y1: 122.173,
    x2: 147.006,
    y2: 154.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudHosting);
export default __webpack_public_path__ + "static/media/Cloud_&_Hosting.580ce6e7366977a1af1cac59b377d963.svg";
export { ForwardRef as ReactComponent };